const is_money = (money) => {
  return Number(money).toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });
};

export default is_money;
